import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d7ca7c24"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7ca7c24')) {
      api.createRecord('d7ca7c24', component.options)
    } else {
      api.reload('d7ca7c24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d7ca7c24", function () {
      api.rerender('d7ca7c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/generate/index.vue"
export default component.exports